import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import TransitionLayout from './animation/TransitionLayout'
import { TransitionProvider } from './context/TransitionContext'
import routes from './routes'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import './styles/index.scss'

const App: React.FC = () => {
  return (
    <TransitionProvider>
      <TransitionLayout>
        <RouterProvider router={routes} />
        <Toaster position='top-right' expand={false} />
      </TransitionLayout>
    </TransitionProvider>
  )
}

export default App
